import { cjnEligibilityCacheHandler, withEligibilityCache } from '../../services/caching/index.tsx';

export const getHasBeenEnrolledInMsr = () => {
	const cachedHasEnrolledMsr = withEligibilityCache('has_enrolled_msr_v1', async () => {
		// The first time this is accessed without being set, it will be set false
		return false;
	});
	return cachedHasEnrolledMsr();
};

export const setEnrolledInMsr = () => {
	return cjnEligibilityCacheHandler.set('has_enrolled_msr_v1', { value: true });
};
